import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import Loader from '../../../loader/Loader'
import Text from '../../../input_filed/Text'
import SelectStatus from '../../../input_filed/SelectStatus'
import SaveButton from '../../../buttons/SaveButton'
import { ToastContainer, toast } from 'react-toastify'
import { useFormik } from 'formik'
import SingleSelect from '../../../input_filed/SingleSelect'
import File from '../../../input_filed/File'
import { useDispatch, useSelector } from 'react-redux'
import { CategoryListRes, CategoryListTodo } from '../../../../redux/slices/master_slice/vehical_category/CategoryList'
import { VehicleTypeListTodo } from '../../../../redux/slices/master_slice/vehicle type/VehicleTypeList'
import { VehicleCCListTodo } from '../../../../redux/slices/master_slice/vehicle cc/VehicleCCList'
import { ModelListRes, ModelListTodo } from '../../../../redux/slices/master_slice/vehical modal/ModalList'
import { BrandListTodo } from '../../../../redux/slices/master_slice/vehical_brand/BrandList'
import { VehicleSchema } from './Validation'
import MultiFiles from '../../../input_filed/MultiFiles'
import { AddVehicleRes, AddVehicleTodo } from '../../../../redux/slices/master_slice/vehicle/AddVehicle'
import { useNavigate } from 'react-router-dom'
import TextArea from '../../../input_filed/TextArea'

export default function AddVehicleForm() {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const categoryList = useSelector(state => state?.CategoryList?.data?.data)
    const typeList = useSelector(state => state?.VehicleTypeList?.data?.data)
    const ccList = useSelector(state => state?.VehicleCC?.data?.data)
    const brandList = useSelector(state => state?.BrandList?.data?.data)
    const modelList = useSelector(state => state?.ModalList?.data?.data)
    const modelRef = useRef()

    const category_option = categoryList && categoryList.map(val => (
        { "value": val.id, "label": val.vehicle_category_name }
    ))
    const type_option = typeList && typeList.map(val => (
        { "value": val.id, "label": val.vehicle_type_name }
    ))
    const cc_option = ccList && ccList.map(val => (
        { "value": val.id, "label": val.vehicle_cc_name }
    ))
    const brand_option = brandList && brandList.map(val => (
        { "value": val.id, "label": val.vehicle_brand_name }
    ))
    const model_option = modelList && modelList.map(val => (
        { "value": val.id, "label": val.vehicle_model_name }
    ))

    const initialValues = {
        category: '',
        type: '',
        cc: '',
        brand: '',
        model: '',
        vehicle_name: '',
        vehicle_img: '',
        vehicle_icon: '',
        vehicle_description:'',
        status: ''
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: VehicleSchema,

        onSubmit: (values, action) => {
            // console.log(values.vehicle_img.length)
            setLoading(true)
            dispatch(AddVehicleTodo(bodyFormData)).then(() => add_res(action))
        }
    })

    let bodyFormData = new FormData();
    bodyFormData.append("user_id", localStorage.getItem('user_id'))
    bodyFormData.append("vehicle_category_id", values.category)
    bodyFormData.append("vehicle_type_id", values.type)
    bodyFormData.append("vehicle_cc_id", values.cc)
    bodyFormData.append("vehicle_brand_id", values.brand)
    bodyFormData.append("vehicle_model_id", values.model)
    bodyFormData.append("vehicle_name", values.vehicle_name)
    bodyFormData.append("vehicle_icon", values.vehicle_icon)

    for (var i = 0; i < values.vehicle_img.length; i++) {
        var file = values.vehicle_img[i];
        bodyFormData.append('vehicle_image', file);
    }
  
    bodyFormData.append("vehicle_description", values.vehicle_description)
    bodyFormData.append("vehicle_status", values.status)

    const add_res = () => {
        if (AddVehicleRes?.success) {
            setLoading(false)
            toast.success(AddVehicleRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                navigate('/vehicle-list')
            }, 1000);
        } else {
            setLoading(false)
            toast.error(AddVehicleRes?.message, { position: "bottom-right" });
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(CategoryListTodo()).then(() => list_res())
    }, [])

    const load_model = (id) => {
        dispatch(ModelListTodo({ id, status: "active" })).then(() => model_res())
        modelRef && modelRef.current && modelRef.current.setValue([])
    }

    const model_res = () => {
        if (ModelListRes?.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const list_res = () => {
        if (CategoryListRes?.success) {
            dispatch(VehicleTypeListTodo()).then((type_res) => {
                if (type_res?.payload?.success) {
                    dispatch(VehicleCCListTodo()).then((cc_res) => {
                        if (cc_res?.payload?.success) {
                            dispatch(BrandListTodo()).then((brand_res) => {
                                if (brand_res?.payload?.success) {
                                    setLoading(false)
                                    // load_model()
                                } else {
                                    setLoading(false)
                                }
                            })
                        } else {
                            setLoading(false)
                        }
                    })
                } else {
                    setLoading(false)
                }
            })
        } else {
            setLoading(false)
        }
    }

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className='form_layout mt-3'>
                    {loading ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :
                        <div className='row'>

                            <div className='col-md-3 mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    required={true}
                                    label_name='Category'
                                    option={category_option ? category_option : []}
                                    disabled={false}
                                    name='category'
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('category', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.category && touched.category ? (<span className='text-danger form_label' >{errors.category}</span>) : null}
                                />
                            </div>
                            <div className='col-md-3 mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='Type'
                                    option={type_option ? type_option : []}
                                    disabled={false}
                                    name='type'
                                    required={true}
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('type', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.type && touched.type ? (<span className='text-danger form_label' >{errors.type}</span>) : null}
                                />
                            </div>
                            <div className='col-md-3 mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='CC'
                                    disabled={false}
                                    option={cc_option ? cc_option : []}
                                    required={true}
                                    name='cc'
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('cc', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.cc && touched.cc ? (<span className='text-danger form_label' >{errors.cc}</span>) : null}
                                />
                            </div>
                            <div className='col-md-3 mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='Brand'
                                    option={brand_option ? brand_option : []}
                                    disabled={false}
                                    required={true}
                                    name='brand'
                                    defaultValue={''}
                                    onChange={(e) => {
                                        load_model(e.value);
                                        setFieldValue('brand', e.value)
                                    }}
                                    onBlur={handleBlur}
                                    error={errors.brand && touched.brand ? (<span className='text-danger form_label' >{errors.brand}</span>) : null}
                                />
                            </div>
                            <div className='col-md-3 mb-2'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='Model'
                                    reference={modelRef}
                                    required={true}
                                    disabled={false}
                                    option={model_option ? model_option : []}
                                    name='model'
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('model', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.model && touched.model ? (<span className='text-danger form_label' >{errors.model}</span>) : null}
                                />
                            </div>

                            <div className='col-md-3 mb-2'>
                                <Text
                                    label_name='Vehicle Name'
                                    placeholder=''
                                    name='vehicle_name'
                                    value={values.vehicle_name || ''}
                                    required={true}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.vehicle_name && touched.vehicle_name ? (<span className='text-danger form_label' >{errors.vehicle_name}</span>) : null}
                                />
                            </div>
                            <div className='col-md-3 mb-2 '>
                                <File
                                    name='vehicle_img'
                                    label_name={'Vehicle Image '}
                                    required={true}
                                    onBlur={handleBlur}
                                    onChange={(e) => setFieldValue("vehicle_img", e.currentTarget.files)}
                                    error={errors.vehicle_img && touched.vehicle_img ? (<span className='text-danger form_label' >{errors.vehicle_img}</span>) : null}
                                />

                            </div>
                            <div className='col-md-3 mb-2 '>
                                <File
                                    name='vehicle_icon'
                                    label_name={'Vehicle Icon '}
                                    onBlur={handleBlur}
                                    onChange={(e) => setFieldValue("vehicle_icon", e.currentTarget.files[0])}
                                    // error={errors.vehicle_icon && touched.vehicle_icon ? (<span className='text-danger form_label' >{errors.vehicle_icon}</span>) : null}
                                />

                            </div>
                         
                            <div className='col-md-3 mb-2'>
                                <SelectStatus
                                    closeMenu={true}
                                    label_name='Status'
                                    disabled={false}
                                    required={true}
                                    name='status'
                                    defaultValue={''}
                                    onChange={(e) =>
                                        setFieldValue('status', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null}
                                />
                            </div>
                            <div className='col-md-9 mb-2'>
                                <TextArea
                                    label_name='Vehicle Description'
                                    placeholder=''
                                    required={true}
                                    rows={4}
                                    name='vehicle_description'
                                    value={values.vehicle_description || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.vehicle_description && touched.vehicle_description ? (<span className='text-danger form_label' >{errors.vehicle_description}</span>) : null}
                                />
                            </div>
                            <div className='col-md-12 text-end mt-2'>
                                <SaveButton name={'Save'} />
                            </div>
                        </div>}
                </div>
            </Form>
            <ToastContainer />
        </>
    )
}
